<template>
    <v-card variant="flat" style="height: 100%; width: 100%;overflow-y: auto; overflow-x: auto;" class="px-4 py-4">
      <v-row class="pa-2 customer">
        <v-col cols="9" class="py-0 d-flex align-center ga-5">
          <h2 class="clientname">Common Alerts</h2>
          <TemplateDownload :data="excelTemplate" text="customers"/>
        </v-col>
        <v-col cols="3" class="py-0 d-flex align-center justify-end">
          <v-btn icon size="28"  @click="toggleForm" color="primary">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      

      <div class="pa-2 table-container mt-4" style="height: 100%; width: 100%; overflow-x: auto;">
        <Table v-if="headers.length > 0" @dialogs="edit" title="Common Alert" :headers="headers" :dataList="dataList" :role="role"/>
      </div>
      
    </v-card>
    <v-dialog v-model="customerDialog" width="700px" persistent>
      
       <v-row class="mt-2 pe-2 " justify="center">
        <v-card  style="width: 600px; height: 550px;border-radius: 20px; position: relative;">
          
          <!-- <v-col cols="12" class="py-0 mx-3 d-flex align-center ga-5">
            <h2 class="mt-2" style="    color: rgb(8, 47, 177);">{{ viewType == "edit"? "Edit": viewType == "view"? "View" : "Add"}} Common Alerts</h2>
            <v-icon icon="mdi-close" size="24" @click="close" style="position: absolute; top: 10px; right: 10px; cursor: pointer;"></v-icon>
          </v-col> -->

          <v-col class="px-7 mt-2" cols="12">
              <div class="d-flex"
                  style="justify-content: space-between !important; align-items: center !important;">
                  <div>
                      <h2 class="main_title">
                          {{ viewType == 'edit'?'Edit': viewType == 'view'?'View':"Add" }} <span style=" color: rgb(8, 47, 177);">{{'Common Alerts'}}</span> 
                      </h2>
                  </div>
                  <span @click="close"  class="mdi mdi-close"></span>
              </div>
            </v-col>

          <v-card-text>
            <v-form ref="form" @submit.prevent="save">
              <v-row class="ma-2">
                <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
                  <v-radio-group
                    :disabled="viewType == 'view' ? true:false"
                    v-model="formData.active"
                    inline
                  >
                    <v-radio color="primary" label="Active" :value="1"></v-radio>
                    <v-radio color="error" label="Inactive" :value="0"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="py-0 px-1">
                  <v-label>Code <span style="color: red;">*</span></v-label>
                  <TextFieldComponent :rules="getRules('Code')" :showReadOnly="viewType == 'view' ? true:false" placeholder="Customer Code" :items="codeOptions" v-model="formData.code" variant="outlined"/>
                  <!-- <AutoComplete :showReadOnly="viewType == 'view' ? true:false" placeholder="Customer Code" :items="codeOptions" v-model="formData.code" variant="outlined" ></AutoComplete> -->
                </v-col>

                <!-- <v-col cols="12" class="py-0 px-1">
                  <v-label>Customer Name</v-label>
                  <AutoComplete :showReadOnly="viewType == 'view' ? true:false" placeholder="Customer Name" :items="nameOptions" v-model="formData.name" variant="outlined" ></AutoComplete>
                </v-col> -->

                <v-col cols="12" class="py-0 px-1">
                  <v-label>Alert Title <span style="color: red;">*</span></v-label>
                  <EnumAutoCompleteVue
                    class="dropdown"
                    density="compact"
                    v-model="formData.title"
                    :domain="'ALERT_TITLE'"
                    placeholder="Alert Title"
                    :selected="formData.title"
                    @changeEnumData="changeTitle($event)"
                    :rules="getRules('Alert Title')"
                  />
                  <!-- <TextFieldComponent :showReadOnly="viewType == 'view' ? true:false" placeholder="Alert Title" v-model="formData.title"  variant="outlined" density="compact" ></TextFieldComponent> -->
                </v-col>

                <v-col cols="12" class="py-0 px-1">
                  <v-label>Remarks <span style="color: red;">*</span></v-label>
                  <v-textarea :rules="getRules('Remarks')" :disabled="viewType == 'view' ? true: false" placeholder="Remarks" v-model="formData.remarks"  variant="outlined" density="compact" rows="3" auto-grow></v-textarea>
                </v-col>

              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-end">
                  <v-btn color="" @click="close" class="me-2">Cancel</v-btn>
                  <v-btn :disabled="viewType == 'view' ? true: false" color="primary" type="submit">{{viewType == "edit" ? 'Save' :'Add' }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-row>
      <!-- <CustomersForm @update-location="updateLocation" :index="index" :viewType="viewType" :designation="'Customers'" :customerForm="customerForm"  @close="close"/> -->
    </v-dialog> 
  
  </template>
  
  <script>
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';
import Table from '@/menus/Table.vue'
import moment from "moment";
import TextFieldComponent from '@/components/TextFieldComponent.vue';
import DatamodelDetailsService from '@/api/service/DataModelDetails/DataModelsDetailsService'
// import AutoComplete from '@/components/ui/AutoComplete.vue';
import EnumAutoCompleteVue from'@/components/others/EnumAutoComplete.vue'
  export default {
    components: {
      // AutoComplete,
      EnumAutoCompleteVue,
      Table,
      TextFieldComponent,
    },
    data() {
      return {
        headers:[
          // {title:"Customer",value:'customer',minWidth:'200px'},
          // {title:"Name",value:'name',minWidth:'300px'},
          // {title:"Factor",value:'factor',minWidth:'150px'},
          // {title:"EDI",value:'edi',minWidth:'150px'},
          // {title:"UCC Lables",value:'ucc_labels',minWidth:'200px'},
          // {title:"Code",value:'code',minWidth:'200px'},
          // {title:"Title",value:'title',minWidth:'200px'},
          // {title:"Remarks",value:'remarks',minWidth:'200px'},
          // // {title:"CustomerType",value:'customer_type',minWidth:'200px'},
          // // {title:"DirectCustomer",value:'direct_customer',minWidth:'200px'},
          // // {title:"855",value:'c855',minWidth:'200px'},
          // // {title:"940&997",value:'c940997',minWidth:'200px'},
          // // {title:"CoursesofAction",value:'courses_of_action',minWidth:'700px'},
          // { title: "Actions", value: 'actions', minWidth: '150px',}
        ],
        viewType:null,
        editIndex:null,
        customerDialog:false,
        customerForm:[],
        customer:[],
        customerDetails:[], 
        currentPath: "Alert",
        user_id:null,
        organisationData:{},
        showForm: false,
        role: null,
        formData:{
          active:1,
          code:null,
          title:null,
          remarks:null
        },
        dataList: [],
        nameOptions: [],
        codeOptions: []
      }
    },

    created() {
        this.getOrganisation();
        this.getModeldata();
        console.log(this.$route,"routess");
        this.currentPath = this.$route.path;
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.user_id = user.id
        this.role = user.roles.role_type
        console.log(this.user_id,"this.user_id!!")
    },
    methods: {
        getRules(name) {
          if (name && name.toLowerCase() === "email") {
              return [
                  (v) => !!v || "E-mail is required.",
                  (v) => /.+@.+\..+/.test(v) || "E-mail must be valid.",
              ];
          }
          return [(v) => !!v || `${name} is required.`];
        },
        changeTitle($event) {
          this.formData.title = $event;
        },
        async getModeldata(){
            try {
              let res = await DatamodelDetailsService.findAll({model_id:22,column_required:1})
              console.log(res,"res!!###")
              this.headers = res || []
              this.headers.forEach((item)=>{
                item.column_name == 'courses_of_action'?item.minWidth='500px':item.minWidth='200px'
                item.title = item.label
                item.value = item.column_name
                // this.excelTemplate.push(item.column_name)
              })
              this.headers.push({ title: "Actions", value: 'actions', minWidth: '150px',})
              console.log(this.headers,"this.headers")
            } catch (error) {
              console.log(error)
            }
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            console.log(this.organisationData,"organisationdata")
            this.dataList = this.organisationData.commonAlerts? this.organisationData.commonAlerts : []
            this.nameOptions = this.organisationData.customers.map(item => item.name)
            this.codeOptions = this.organisationData.customers.map(item => item.customer)
            // this.customerDetails = this.organisationData && this.organisationData.customers ? this.organisationData.customers : this.customerDetails
            console.log(this.dataList,"datalist")
        },

        close() {
            this.customerDialog = false
            this.formData = {}
            // this.viewType = ''
        },
        async save() {
           const validation = await this.$refs.form.validate();
            if (!validation.valid) {
                console.log("Form not valid");
            } else {
              if(this.viewType != 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                let count = 0
                if(this.organisationData && this.organisationData.commonAlerts && Array.isArray(this.organisationData.commonAlerts)){
                  count = this.organisationData.commonAlerts.length
                }
                this.formData.id = count+1
                this.formData.created = now
                this.formData.modified = null
                this.formData.created_by = this.user_id  
                this.formData.modified_by = null
                this.formData.active = 1
                this.formData.deleted = 0
                this.formData.deleted_by = null
                this.dataList.push(this.formData)
                console.log(this.dataList,"orgdata")
                this.organisationData.commonAlerts = this.dataList
                console.log(this.organisationData,'orgdata1')
                let $data = {
                    collectionName: 'organisation',
                    data: this.organisationData,
                    id:this.$route.query.id
                } 
                await clientDetailsService.update($data)
                this.close()
              }
              else{
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                this.formData.modified = now
                this.formData.modified_by = this.user_id
                this.organisationData.commonAlerts[this.editIndex]=this.formData
                console.log(this.organisationData,"elseee")
                let $data = {
                    collectionName: 'organisation',
                    data: this.organisationData,
                    id:this.$route.query.id
                } 
                await clientDetailsService.update($data)
                this.close()
              }
            }
          },
        addCustomer($data){
            this.customerDetails = $data
            let count = 0
            if(this.organisationData && this.organisationData.customers && Array.isArray(this.organisationData.customers)){
              count = this.organisationData.customers.length
            }
            for(let i of this.customerDetails){
              const now = moment().format('YYYY-MM-DD HH:mm:ss')
                i.id = ++count
                i.created = now
                i.modified = null
                i.created_by = this.user_id  
                i.modified_by = null
                i.active = 1
                i.deleted = 0
                i.deleted_by = null
              console.log(i ,"loop")
            }
            this.save()
        console.log(this.customerDetails,'geufeu')
        },

        async edit($edit,bool,viewType,index){
          // alert(1)
          this.customerDialog=true
          this.formData = $edit
          // this.customerForm = $edit
          this.viewType = viewType
          this.editIndex = index
          console.log("$edit !!",$edit,"$edit !!",bool,"$edit !!",viewType,"$edit !!",index)

        },

        updateLocation(data,index,type){
          console.log(data,"updatelocation !!")
            if(type == 'edit'){
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                data.modified = now
                data.modified_by = this.user_id
                this.customerDetails[index] = data
                this.saveAllData()
            }

        },
        async saveAllData() {
            this.organisationData.customers = this.customerDetails
            console.log(this.organisationData,"orgdata")
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
            // window.location.reload()
        },
        toggleForm() {
            this.customerDialog = true
            this.viewType = 'add'
        },
        addAlert() {
            // Logic to add the alert
            console.log('Adding alert:', {
                name: this.alertName,
                code: this.alertCode,
                title: this.alertTitle,
                remarks: this.alertRemarks
            })
            // Reset form
            this.alertName = ''
            this.alertCode = ''
            this.alertTitle = ''
            this.alertRemarks = ''
            this.showForm = false
        },
    },
  };
  </script>
  
  <style scoped>
  .v-label {
    margin-bottom: 3px;
    font-size: 14px;
    opacity: 1;
    font-weight: 600;
  }
  .customer{
    display: flex;
    align-items: center;
  }
  /* .dark-label {
    color: black!important;
  } */
  .upload-btn {
  /* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
  color: white;
  font-weight: 600;
  text-transform: none; /* keep 'Upload' normal instead of uppercase */
  border-radius: 12px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}
  .clientname {
    font-size: 20px;
    font-weight: 600;
  }
  
  .table-container {
    width: 100%;
     /* background: #ebf1f35a; */
    background: #fff;
    padding: 8px 15px;
    border-radius: 4px;
    /* // border: 1px solid #d2d2d2; */

    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0 10px;

        thead {
        border: 1px solid #cbf0fd;
        background-color: #e3f2fd;

        th {
            font-size: 1rem;
            font-weight: 500;
            padding: 12px;
            text-align: left;
            color: #000;
        }
        }

        tbody {
        tr {
            cursor: pointer;
            font-size: 0.9rem;
            font-weight: 500;
            position: relative;
            overflow: hidden;
            border: 1px solid #cbf0fd;
            border-radius: 8px;

            &:nth-child(odd) {
            background-color: #ebf1f3;
            }

            &:nth-child(even) {
            background-color: #d9dbdb;
            }

            td {
            padding: 10px;
            text-align: left;
            color: #333;
            }

            &:hover {
            background-color: #f5f5f5;
            }
        }
        }
    }
    }
    .edit-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    }

    .noWrap{
    text-wrap:nowrap;
    }
    .no-data-container{
    display:flex;
    justify-content:center;
    align-items:center;
    width: 100%;
    height:400px;
    font-size:20px; 
    font-weight:500;
    }

  .main_title {
    font-size: 16px;
    font-weight: 600;
  }
  </style>